import { Component, OnInit, AfterViewInit, OnDestroy, AfterViewChecked } from '@angular/core';
import { Article } from '../../classes/article';
import { Logger } from '../../classes/logger';
import { of, Subscription } from 'rxjs';
import { ComponentState } from '../../types/componentState';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../../services/data/data.service';
import { ContextService } from '../../services/context/context.service';
import { LanguageService } from '../../services/lang/language.service';
import { ScrollService } from '../../services/scroll/scroll.service';
import { LoggerService } from '../../services/logger/logger.service';
import { mergeMap, first, map } from 'rxjs/operators';



@Component({
  selector: "app-article-page-common",
  templateUrl: "./article-page-common.component.html",
  styleUrls: ["./article-page-common.component.scss"]
})
export class ArticlePageCommonComponent implements OnInit, AfterViewChecked, OnDestroy {
  public article: Article;
  public id: string;
  public root: any;
  public showNav: boolean;
  public isMobile: boolean;
  protected logger: Logger;
  private sub: Array<Subscription> = [];
  public state: ComponentState = "loading";

  /**
   * Holds the id to scroll, if any.
   */
  public scrollToFragment: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dataService: DataService,
    private context: ContextService,
    public lang: LanguageService,
    protected scroll: ScrollService,
    loggerSrvc: LoggerService
  ) {
    this.logger = new Logger(loggerSrvc, this.constructor.name);
    this.isMobile = /Android|iPhone/i.test(window.navigator.userAgent);
    this.showNav = this.isMobile ? true : this.context.getShowNav();
  }

  ngOnInit() {
    // Reserve the constructor for simple initialization such as wiring
    // constructor parameters to properties. The constructor shouldn't do anything.
    // It certainly shouldn't call a function that makes HTTP requests to a
    // remote server as a real data service would.
    this.route.params.pipe().subscribe(
      params => this.processParams(params),
      error => this.processError(error)
    );
  }

  /**
   * {@inheritdoc}
   *
   * @memberof ArticlePageCommonComponent
   */
  ngAfterViewChecked(): void {
    if (this.scrollToFragment) {
      let elem = document.querySelector("#" + this.scrollToFragment);
      if (elem) {
        elem.scrollIntoView();
        this.scrollToFragment = null;
      }

    }
  }


  public processParams(params) {
    this.showNav = this.isMobile ? true : this.context.getShowNav();
    this.id = params["id"];
    this.getArticle();
  }

  getArticle(): void {
    this.sub.push(
      this.lang
        .lang()
        .asObservable()
        .pipe(
          mergeMap(a => {
            return this.dataService.getArticle(this.id).pipe(mergeMap(article => {
              return this.dataService.getIndex(this.id).pipe(
                mergeMap(index => {
                  if (index.currentFile) {
                    Object.assign(article, { lastUpdate: index.currentFile.version });
                    return of(article);
                  } else {
                    return this.dataService.getIndex(article.parent).pipe(mergeMap(index => {
                      if (index.currentFile) {
                        Object.assign(article, { lastUpdate: index.currentFile.version });
                        return of(article);
                      }
                      return of(article);
                    }));
                  }

                })
              )

            }));
          }),

        )
        .subscribe(
          article => this.processReceivedArticle(article),
          err => this.processError(err)
        )
    );
  }
  ngOnDestroy() {
    this.sub.forEach(value => value.unsubscribe());
  }
  processReceivedArticle(article: Article) {
    this.article = article;

    // If article parent it's 0 means that is a book root, we want to
    // show book children instead of book brothers. In other case we use main
    // parent to show the index.
    this.root =
      Number(this.article.parent) == 0
        ? this.article.id
        : this.article.mainParent.id;
    // Check if is a inner article to redirect to main contanier.
    if (this.article.level > 1) {
      this.logger.info(
        `This is an INNNER article, redirecting to container article ${this.article.mainIndex}`
      );
      this.router.navigate(["/rulebook/article/" + this.article.mainIndex], {
        queryParams: this.isMobile === true ? { 'book_title': article.parents[article.parents.length - 1].label } : {},
        queryParamsHandling: "merge",
        fragment: this.article.elemId,
        replaceUrl: true
      });
    } else {
      this.state = "settled";
      this.route.fragment.subscribe(value => this.processFragment(value));
    }
  }

  processError(error: any): void {
    this.state = "error";
    this.logger.error(`Error in ${this.constructor.name} (BA5E03CD)`, error);
  }

  processFragment(fragment: string) {
    if (fragment) {
      this.scrollToFragment = fragment;
    } else {
      this.scroll.scrollToContentOnNavigationEnd();
    }
  }

  toggleNavigation() {
    this.context.setShowNav(!this.showNav);
    this.showNav = this.context.getShowNav();
  }
}
